export function formatLegalDate(value: string, locale: 'en' | 'ru'): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return value;
  const [, year, month, day] = match;
  if (locale === 'ru') return `${day}.${month}.${year}`;
  return new Intl.DateTimeFormat('en', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' })
    .format(Date.UTC(Number(year), Number(month) - 1, Number(day)));
}
